export default {
  path: '/materials',
  name: 'materials',
  component: () => import('../components/material/Layout'),
  redirect: { name: 'MaterialList' },
  meta: {
    breadcrumb: 'material.materials',
  },
  children: [
    {
      name: 'MaterialList',
      path: '',
      component: () => import('../views/material/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialCreate',
      path: 'new',
      component: () => import('../views/material/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialUpdate',
      path: ':id/edit',
      component: () => import('../views/material/Update'),
      meta: {
        breadcrumb: 'material.material',
      },
    },
    {
      name: 'MaterialShow',
      path: ':id',
      component: () => import('../views/material/Show'),
      meta: {
        breadcrumb: 'material.material',
      },
    }
  ]
};
